import React, { useState, useEffect } from "react";
import apiClient from "../../../../api/apiClient";
import Loading from "../../../../components/Loading/Loading";

const CRMReports = ({ userProfile }) => {
    const [activityReport, setActivityReport] = useState(null);
    const [pipelineReport, setPipelineReport] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            apiClient.get("/admin/crm/reports/activity"),
            apiClient.get("/admin/crm/reports/pipeline"),
        ]).then(([a, p]) => {
            setActivityReport(a.data);
            setPipelineReport(p.data);
        }).catch(console.error)
          .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="admin-loading-wrapper"><Loading /></div>;

    const maxFunnel = Math.max(...(pipelineReport?.funnelData?.map((d) => d.leadCount) || [1]), 1);

    return (
        <div>
            {/* Conversion funnel */}
            {pipelineReport?.funnelData?.length > 0 && (
                <div className="crm-chart-container">
                    <p className="crm-chart-title">Pipeline Funnel</p>
                    <div className="crm-bar-chart">
                        {pipelineReport.funnelData.map((s) => (
                            <div key={s.name} className="crm-bar-row">
                                <span className="crm-bar-label">{s.name}</span>
                                <div className="crm-bar-track">
                                    <div
                                        className="crm-bar-fill"
                                        style={{
                                            width: `${(s.leadCount / maxFunnel) * 100}%`,
                                            backgroundColor: s.color || "#6b7280",
                                        }}
                                    />
                                </div>
                                <span className="crm-bar-count">{s.leadCount}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Rep performance (superadmin sees all, admin sees own) */}
            <div className="crm-chart-container">
                <p className="crm-chart-title">
                    {userProfile === "superadmin" ? "Rep Performance" : "My Performance"}
                </p>
                {activityReport?.repPerformance?.length > 0 ? (
                    <div className="admin-table-scroll">
                        <table className="crm-rep-table">
                            <thead>
                                <tr>
                                    <th>Rep</th>
                                    <th>Leads Owned</th>
                                    <th>Converted</th>
                                    <th>Conversion %</th>
                                    <th>Activities Logged</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activityReport.repPerformance.map((rep) => {
                                    const convRate = rep.leadsOwned > 0
                                        ? Math.round((rep.converted / rep.leadsOwned) * 100)
                                        : 0;
                                    return (
                                        <tr key={rep.userId}>
                                            <td>{rep.firstName} {rep.lastName}</td>
                                            <td>{rep.leadsOwned}</td>
                                            <td>{rep.converted}</td>
                                            <td>{convRate}%</td>
                                            <td>{rep.activitiesLogged}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="crm-empty">No data available.</p>
                )}
            </div>
        </div>
    );
};

export default CRMReports;
